import qs from 'query-string';

import { entityTypeToApiType } from 'helpers/mapEntityTypes';

import { EntityTypes, SalesTypes } from 'context/entityContext';
import { sortOrderTypes } from 'types/shared';
import getCountryIds from 'helpers/getCountryIds';
import { MAX_LIMIT } from 'config';

interface IBrowseVersionsUrlArgs {
  entityType: EntityTypes;
  entityIds: string[];
  salesType?: SalesTypes;
  customerFilter?: number[];
  sortOrder?: sortOrderTypes;
  sortby?: string;
  secondarySortby?: string;
  countryIds?: string;
  limit?: number;
  offset?: number;
  mediaTypes?: string;
  region?: string;
  releaseType?: string;
  customRegion?: string | string[];
}

export default function getBrowseVersionsUrl(
  args: IBrowseVersionsUrlArgs
): string {
  const {
    entityType,
    entityIds,
    salesType,
    customerFilter,
    sortOrder,
    sortby,
    secondarySortby,
    countryIds,
    limit = MAX_LIMIT,
    offset,
    mediaTypes,
    region,
    releaseType,
    customRegion,
  } = args;

  const type = entityTypeToApiType(entityType);
  const params = qs.stringify({
    salesType,
    customerFilter,
    sortOrder,
    sortby,
    countryIds: getCountryIds(countryIds, region, customRegion),
    limit,
    offset,
    mediaTypes,
    releaseType,
    secondarySortby: type !== 'labels' ? (secondarySortby || 'performance_last_week') : undefined,
    secondarySortOrder: 'desc',
  });

  return `/api/browse/${type}/${entityIds}/versions?${params}`;
}
